import { render, staticRenderFns } from "./red-packet-pop.vue?vue&type=template&id=d4f84c3c&scoped=true&"
import script from "./red-packet-pop.vue?vue&type=script&lang=js&"
export * from "./red-packet-pop.vue?vue&type=script&lang=js&"
import style0 from "./red-packet-pop.vue?vue&type=style&index=0&id=d4f84c3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f84c3c",
  null
  
)

export default component.exports